var removeGhostCharacter = function removeGhostCharacter(str) {
  return str ? str.replace(//g, '') : '';
};

export function trimmer(str, max, small) {
  if (!small || !str || str.length <= max) {
    return removeGhostCharacter(str);
  }

  var trimmedString = str.substr(0, max);
  var newString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')));
  return removeGhostCharacter(newString.length === str ? str : "".concat(newString.replace(/,$/, ''), "..."));
}